<template>
  <div class="aside-calllog">
    <search-input
      :value="search"
      @onSearch="handleLogsSearch"
    />
    <call-logs-tabs @tab-changed="handleTabChange" />
    <call-log-list
      :active-tab="activeTab"
      :search
    />
  </div>
</template>

<script>
  import SearchInput from '@/components/SharedComponents/Inputs/SearchInput.vue';

  import CallLogList from './CallLogList/CallLogList.vue';
  import CallLogsTabs from './CallLogsTabs.vue';

  export default {
    name: 'AsideCallLog',
    components: {
      SearchInput,
      CallLogList,
      CallLogsTabs,
    },
    data() {
      return {
        activeTab: 'all',
        search: '',
        timeOutId: null,
      };
    },
    methods: {
      handleTabChange(tab) {
        this.activeTab = tab;
      },
      async handleLogsSearch(search) {
        if (this.timeOutId) {
          clearTimeout(this.timeOutId);
        }
        this.timeOutId = setTimeout(async () => {
          this.search = search;
        }, 500);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .aside-calllog {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
  }
</style>
